require("./disclaimers.scss");

(function ($, window) {
  $.extend($.fn, {
    csnScroll: function () {
      if ( !this.length ) {
        if ( window.console ) {
          console.warn( "Nothing selected, can't validate, returning nothing." );
        }
        return;
      }

      $(this).each(function () {
        if(this.getAttribute("init")) return;

        $(this).on('click', function () {
          let target = this.getAttribute("data-target");
          if(!target || $(target).length == 0) return;
        
          let duration = this.getAttribute("data-duration");
          if(!duration || isNaN(duration)) duration =  300;
          else duration = parseInt(duration);

          let offset = this.getAttribute("data-offset");
          if(!offset) offset = 0;

          let targetScrollPosition = $(target)[0].getBoundingClientRect().top + window.scrollY - offset;
          $("html,body").animate({scrollTop: targetScrollPosition}, duration);
        });

        this.setAttribute('init', true);
      });
      
    }
  });

  $(function () {
    $("[data-toggle='scroll']").csnScroll();

    window.addEventListener("collect-disclaimer", function (evt) {
      var content = $("<p />").html(evt.detail);
      var divWrapper = $("<div />");
      divWrapper
        .addClass("disclaimers-item")
        .append(content);
      
      $(".disclaimers-wrapper").append(divWrapper);
    })
  });
})(jQuery, window);
